// src/httpClient.ts
import axios from "axios";
var normalizeAxiosError = (error) => {
  if (!axios.isAxiosError(error)) {
    const apiError2 = {
      kind: "unknown",
      message: "Something went wrong.",
      cause: error
    };
    console.error("Unexpected error:", error);
    return apiError2;
  }
  const axiosError = error;
  let apiError;
  if (axiosError.code === "ECONNABORTED") {
    apiError = {
      kind: "timeout",
      message: "The request took too long.",
      cause: axiosError
    };
  } else if (!axiosError.response) {
    apiError = {
      kind: "network",
      message: "Could not reach the server.",
      cause: axiosError
    };
  } else {
    const status = axiosError.response.status;
    if (status >= 400 && status < 500) {
      apiError = {
        kind: "client",
        message: "The request could not be completed.",
        status,
        cause: axiosError
      };
    } else if (status >= 500) {
      apiError = {
        kind: "server",
        message: "The server had a problem handling the request.",
        status,
        cause: axiosError
      };
    } else {
      apiError = {
        kind: "unknown",
        message: "Something went wrong.",
        status,
        cause: axiosError
      };
    }
  }
  console.error(`API error [${apiError.kind}]:`, axiosError);
  return apiError;
};
var createHttpClient = (baseURL, timeout = 15e3) => {
  const httpClient = axios.create({ baseURL, timeout });
  httpClient.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(normalizeAxiosError(error))
  );
  return httpClient;
};
export {
  createHttpClient,
  normalizeAxiosError
};
